import { EmploymentStatus } from '@zorro/clients';
import { Pill } from '@zorro/design-system/v2/Pill';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { FlagIcon } from '@zorro/shared/assets';

import { getEligibilityStatusBadgeConfig } from './EligibilityStatusBadgeUtils';

const WITH_DOT_STATUSES = new Set<EmploymentStatus>([
  EmploymentStatus.ELIGIBLE_ENDING,
  EmploymentStatus.ELIGIBLE_UPCOMING_LEAVE,
]);

type Props = {
  employmentStatus: EmploymentStatus;
  eligibleFrom?: string | null;
  eligibleUntil?: string | null;
  leaveOfAbsenceStartDate?: string | null;
  leaveOfAbsenceEndDate?: string | null;
  createdAt?: string;
  terminationDate?: string | null;
  hasPreviousEligibility?: boolean | null;
};

export const EligibilityStatusBadgeTooltip = ({
  employmentStatus,
  eligibleFrom,
  eligibleUntil,
  leaveOfAbsenceStartDate,
  leaveOfAbsenceEndDate,
  createdAt,
  terminationDate,
  hasPreviousEligibility,
}: Props) => {
  const { label, color, description } = getEligibilityStatusBadgeConfig(
    employmentStatus,
    eligibleFrom,
    eligibleUntil,
    leaveOfAbsenceStartDate,
    leaveOfAbsenceEndDate,
    createdAt,
    terminationDate,
    hasPreviousEligibility
  );

  const icon = (
    <FlagIcon
      flagColor="transparent"
      withDot={WITH_DOT_STATUSES.has(employmentStatus)}
    />
  );

  return (
    <Tooltip position="top" label={description}>
      <Pill variant="with-icon" color={color} leftSection={icon}>
        {label}
      </Pill>
    </Tooltip>
  );
};
